import React from 'react';
import PageWrapper from './PageWrapper';

import { DeltaUpIcon, DeltaRightIcon} from './Components'
import { RowFlexDiv, ColFlexDiv } from './Components';
import { BigFigure, InformationItem, MixerlabText, Header } from './Components';

import './Animations.scss'

class ActorSessionHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      detailedFeedbackView: false
    };
  }

  render() {
    return (
      <PageWrapper isAdmin={this.props.isAdmin}>
      <div style={{'width': '100%'}}>
        {this.props.last_session_summary=='' && 
          <MixerlabText>
            No session history found.
          </MixerlabText>
        }
        {this.props.last_session_summary!=='' && 
        <div>
        <Header>Summary of {this.props.session_source.toUpperCase()} Session: {this.props.session_name}</Header>
        <MixerlabText>
          <RowFlexDiv>
            <ColFlexDiv style={{'alignItems':'start', 'margin': '10px'}}>
              <BigFigure style={{'marginLeft':'10px'}} >
                {this.props.num_accepted}
                </BigFigure>
              <InformationItem>Accepted Conversations</InformationItem>
            </ColFlexDiv>
            <ColFlexDiv style={{'alignItems':'start', 'margin': '10px'}}>
              <BigFigure style={{'marginLeft':'10px'}}>{this.props.num_rejected}</BigFigure>
              <InformationItem>Rejected Conversations</InformationItem>
            </ColFlexDiv>
          </RowFlexDiv>
          {!this.state.detailedFeedbackView && <div style={{'marginLeft': '10px'}} onClick={() => this.setState({detailedFeedbackView: true})}>View Conversation Details: <DeltaRightIcon /></div>}
          {this.state.detailedFeedbackView && <div style={{'marginLeft': '10px'}} onClick={() => this.setState({detailedFeedbackView: false})}>Collapse Conversation Details: <DeltaUpIcon /></div>}
          {(this.state.detailedFeedbackView) && 
            <div>
              {this.props.feedback &&
                <ul>
                  {this.props.feedback.split('\n').map((line) => {
                    if (line !== '') {
                      return(<li>{line}</li>)
                    }
                    })}
                </ul>
              }
            </div>
          }
        </MixerlabText>
        </div>}
      </div>
      </PageWrapper>
    )
  }
}

export default ActorSessionHistory;